const init_plp_navigation = () => {
  // Enable Smooth Scrolling & Add Scroll Padding
  const html_element = document.querySelector('html')
  html_element.classList.add('scroll-p-[225px]', 'scroll-smooth')

  // Handle Product Card Mobile Value Props Toggle
  const product_card_value_props_toggle = document.querySelectorAll(
    '.product-props-toggle'
  )

  product_card_value_props_toggle.forEach((value_props_toggle) => {
    value_props_toggle.addEventListener('click', () => {
      value_props_toggle.parentNode.classList.toggle('active')
    })
  })

  // Handle Product Card Featured Image Carousel
  new Swiper('.collection-product-card-swiper', {
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    loop: true
  })

  // Handle Product Availability
  const update_product_availabilities = () => {
    const customer_selected_zip_code = window.Scoutside.LocationState.zipcode
    const customer_selected_store_location =
      window.Scoutside.LocationState.selectedLocation
    const product_cards = document.querySelectorAll(
      '[data-product-id]'
    )
    const pickup_locations = document.querySelectorAll(
      '[data-available-pickup-locations]'
    )

    const whitelisted_elements = document.querySelectorAll(
      '[data-whitelisted-zipcodes]'
    )

    let delivery_only_zipcodes = []
    const delivery_only_locations = window.Scoutside.shop.deliveryOnlyLocations
    delivery_only_locations.forEach((location) => {
      if (location?.metafield?.value) {
        delivery_only_zipcodes.push(location.metafield.value.flat())
      }
    })
    delivery_only_zipcodes = delivery_only_zipcodes.flat()

    console.log('Updating Product Availabilities')

    // Loop through each store and check against the customer's selected store for pickup availability, or store nearest to zip code for delivery availability
    product_cards.forEach((product_card) => {
      const product_availability_element = product_card.querySelector(
        '[data-available-pickup-locations]'
      )

      // set default values on element
      product_card.dataset.deliveryAvailable = false;

      if (!product_availability_element) {
        return
      }

      // set default values on element
      product_availability_element.classList.remove(
        'pickup-available',
        'delivery-available'
      )

      const nationwide_shipping = product_availability_element.getAttribute(
        'data-nationwide-shipping'
      )

      const available_pickup_locations =
        product_availability_element.getAttribute(
          'data-available-pickup-locations'
        )

      const whitelisted_zipcodes =
        product_availability_element.getAttribute(
          'data-whitelisted-zipcodes'
        )

      const product_type =
        product_availability_element.getAttribute('data-product-type')

      const displayPickupOption = (
        product_availability_element.dataset.productType === 'Sod' ||
        product_availability_element.dataset.hasPickupVariant === 'true'
      )

      // If this product has available pickup locations, parse the JSON string into an array
      if (available_pickup_locations) {
        const available_pickup_stores_array = JSON.parse(
          available_pickup_locations
        )

        const whitelist = whitelisted_zipcodes ? JSON.parse(whitelisted_zipcodes) : []

        // If the customer's selected location matches the available pickup locations, add the pickup-available class
        if (
          displayPickupOption &&
          available_pickup_stores_array.includes(
            customer_selected_store_location
          )
        ) {
          product_availability_element.classList.add('pickup-available')
          product_card.dataset.deliveryAvailable = true;
        }

        /* Updated Availability Checks - Nov 28, 2023 */
        const all_locations = window.Scoutside.LocationState.locations
        all_locations.forEach((location) => {
          // If we have zip zones for this store, check if the customer's selected zip code is in the available zip codes
          if (location?.metafield?.value) {
            const location_zip_codes = JSON.parse(
              location.metafield.value
            ).flat()

            // If nationwide shipping is available or the customer's selected zip code is in the available zip codes and the location is in the available pickup locations, add the delivery-available class
            if (
              nationwide_shipping === 'true' || (
              location_zip_codes.includes(customer_selected_zip_code) &&
              (available_pickup_stores_array.includes(location.id) ||
                (delivery_only_zipcodes.includes(customer_selected_zip_code) &&
                  product_type !== 'Sod')) &&
              (whitelist.length === 0 || whitelist.includes(customer_selected_zip_code))
              )) {
              product_availability_element.classList.add('delivery-available')
            }
          }
        })
      }
    })

    whitelisted_elements.forEach((whitelisted_element) => {
      whitelisted_element.classList.remove('delivery-unavailable')
      const whitelisted_zipcodes = whitelisted_element.getAttribute('data-whitelisted-zipcodes')
      const whitelist = whitelisted_zipcodes ? JSON.parse(whitelisted_zipcodes) : []
      if (whitelist.length > 0 && !whitelist.includes(customer_selected_zip_code)) {
        whitelisted_element.classList.add('delivery-unavailable')
      }
    })
  }

  // On zip code change, update product availabilities
  document.addEventListener('orderLocations', () => {
    update_product_availabilities()
  })

  // On store change, update product availabilities
  document.addEventListener('setSelectedLocation', () => {
    update_product_availabilities()
  })

  update_product_availabilities()

  // Handle Product Sub Collection Navigation
  const update_link_state = () => {
    const current_hash = window.location.hash
    const plp_nav_items = document.querySelectorAll('.plp-nav-item')

    plp_nav_items.forEach((item, index) => {
      if (item.getAttribute('href') === current_hash) {
        item.classList.add('active')
      } else if (current_hash === '' && index === 0) {
        item.classList.add('active')
      } else {
        item.classList.remove('active')
      }
    })
  }
  // Detect when the hash changes and update the plp-nav-item active class accordingly
  window.addEventListener('hashchange', () => {
    update_link_state()
  })
  update_link_state()
}
init_plp_navigation()
